import { useContext, useCallback } from 'react';
import { LocalStorageContext } from '../providers/LocalStorageProvider';

// previous: https://usehooks.com/useLocalStorage/
// should be used in tandem with LocalStorageProvider
// what it does: it syncs states between different browser tabs

export const useSelector = (callback: (state: any) => any) => {
  const ls = useContext(LocalStorageContext);
  return ls?.getValue(callback) ?? null;
}

export const useDispatch = () => {
  const ls = useContext(LocalStorageContext);
  return ls?.dispatch ?? null;
}

export const useLocalStorage = <T = unknown>(key: string, initialValue?: T): [T | undefined, (state: T) => void] => {

  const dispatch = useDispatch();
  const value = useSelector(state => state[key]) as T;

  const setValue = useCallback((value: T) => {
    if (dispatch) {
      dispatch({ type: 'set', key, value });
    }
  }, [key, dispatch]);

  return [value ?? initialValue, setValue];
}